import gql from "graphql-tag";

export const Coach = () => gql`
  fragment Coach on Coach {
    id
    phone
    description
    type
    user {
      id
      userName
      firstName
      lastName
      domain
      email
      phone
      description
      languageCode
      type
      image
      gender
      birthDate
      country
    }
    permissions {
      ...CoachPermissions
    }
  }
  ${CoachPermissions()}
`;

export const CoachPermissions = () => gql`
  fragment CoachPermissions on CoachPermissions {
    coaching
    sharedLibrary
    campaignPages
    insights
    finance
    account
    exerciseLibrary
    coaches
    shop
    companyPackages
    teamboosts
    storefront
  }
`;
